<template>
  <div>
    <title-edit header="Floor" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="6" xs="12" style="float: right">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Floor name* :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-text-field :model="form.floor_name" @update="updateFloorName" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Floor number* :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-text-field :model="form.floor_number" @update="updateFloorNumber" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>Image :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 500KB
        </div>
      </v-col>
      <v-col cols="12" sm="6" xs="12">
        <input-image-upload
          height="150px"
          width="150px"
          col="col-6"
          id="1"
          menu="floor"
          :model="form.image_url_show"
          @update="updateImage"
        />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteFloor" @save-info="saveFloor" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import InputTextField from "../../../components/Input/InputTextField";
import InputEditor from "../../../components/Input/InputEditor";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import { mapState } from "vuex";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import SelectOption from "../../../components/Input/selectOption";
import {permissionFloor, role} from "../../../util/Permission";
import Swal from "sweetalert";
import CommandButton from "../../../components/Layout/CommandButton";

export default {
  name: "FloorEdit",
  components: {
    CommandButton,
    SelectOption,
    InputImageUpload,
    SaveButton,
    PreviewButton,
    DeleteButton,
    InputEditor,
    InputTextField,
    LineHr,
    TitleEdit
  },
  data() {
    return {
      optionBranch: [],
      permission : null,
    };
  },
  computed: {
    permissionFloor,
    ...mapState({
      form: state => {
        return state.Floor.form;
      }
    })
  },
  created() {
    this.permission = role;
    this.getBranchData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: null },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    goToFloorTable() {
      this.$router.push("/services/floor");
    },
    validateSave() {
      if (!this.form.floor_name) {
        Swal('','Please select Floor name !','error');
        return false;
      } else if (!this.form.floor_number) {
        Swal('','Please insert Floor number !','error');
        return false;
      } else {
        return true;
      }
    },
    saveClose() {
      if (this.validateSave()) {
        this.$store
                .dispatch("Floor/saveFloor", {
                  id: this.form.floor_id,
                  data: this.form
                })
                .then(res => {
                  Swal(res.response_msg);
                  if (res.response_code == 200) {
                    this.goToFloorTable();
                  }
                })
                .catch(() => {
                  Swal('','Cannot save floor data','error');
                });
      }
    },
    saveFloor() {
      if (this.validateSave()) {
        this.$store
          .dispatch("Floor/saveFloor", {
            id: this.form.floor_id,
            data: this.form
          })
          .then(res => {
            Swal(res.response_msg);
          })
          .catch(() => {
            Swal('','Cannot save floor data','error');
          });
      }
    },
    deleteFloor() {
      this.$store
        .dispatch("Floor/deleteFloor", this.form.floor_id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToFloorTable();
          }
        })
        .catch(() => {
          Swal('','Cannot delete floor data','error');
        });
    },
    updateFloorName(val) {
      this.form.floor_name = val;
    },
    updateFloorNumber(val) {
      this.form.floor_number = val;
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateImage(val) {
      this.form.image_url = val.imagePath;
      this.form.image_url_show = val.fullImagePath;
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/switch.css";
</style>
